import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";

async function getAllInventoryCampaignAltVersion(id) {
    try {
        const token = getToken();
        const response = await axiosInstance.get(`/api/inventory-campaigns-alt-versions/all?inventory_campaign=${id}`, {
            headers: {
                'Authorization': token
            }
        });

        return response?.data;
    } catch (error) {
        console.log(error);
        throw error; // Re-throw the error for further handling if needed
    }
}

export default getAllInventoryCampaignAltVersion;
